/* New Wave — rolling promo countdown.
   Each visitor gets their own window; when it lapses a fresh one starts, so the
   offer keeps looping. Supports any number of instances on a page, all sharing
   one deadline so the timers never disagree with each other. */
(function () {
  if (customElements.get('nw-promo-timer')) return;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  customElements.define('nw-promo-timer', class extends HTMLElement {
    connectedCallback() {
      this.timeEl = this.querySelector('[data-nw-promo-time]');
      if (!this.timeEl) return;

      this.periodMs = (parseFloat(this.dataset.hours) || 24) * 3600 * 1000;
      this.key = this.dataset.storageKey || 'nw-promo';

      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);

      // Safari suspends timers in background tabs — resync on return.
      this.onVisible = () => { if (!document.hidden) this.tick(); };
      document.addEventListener('visibilitychange', this.onVisible);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.onVisible);
    }

    /* Read on every tick rather than caching, so sibling instances stay in
       lockstep and a rollover in one is picked up by the rest. */
    deadline() {
      var now = Date.now();
      var stored = null;
      try { stored = window.localStorage.getItem(this.key); } catch (e) {}

      var d = stored ? parseInt(stored, 10) : NaN;
      if (!d || isNaN(d) || d <= now) {
        d = now + this.periodMs;
        try { window.localStorage.setItem(this.key, String(d)); } catch (e) {}
      }
      return d;
    }

    tick() {
      var remaining = this.deadline() - Date.now();
      if (remaining < 0) remaining = 0;

      var total = Math.floor(remaining / 1000);
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;

      this.timeEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
  });
})();
